var exports = {
  "i": "LiveBadge.module__liveBadge___Z2pfem",
  "f": "LiveBadge.module__liveBadgeOnVoiceTile___Z2pfem",
};

module.exports = exports;
